(function (angular) {
	'use strict';

	var progressBarObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			completedAmount: '<',
			onlyBar: '<?',
			pendingAmount: '<?',
			theme: '@',
			total: '<'
		},
		controller: [
			'$timeout', 
			'Big',
			ProgressBarFunction
		],
		controllerAs: 'progressBar'
	};

	angular
		.module('progressBarModule')
		.component('progressBar', progressBarObject);

	function templateUrlFunction(STATIC_BASE_PATH) {
		return STATIC_BASE_PATH + '/static/html/shared/progress-bar/progress-bar.html'; 
	}

	function ProgressBarFunction(
		$timeout,
		Big
	) {
		var progressBar = this;

		progressBar.completedBarWidth = 0;
		progressBar.pendingBarWidth = 0;

		function setWidthPercentages() {
			var total = new Big(progressBar.total);
			var completedBarWidth = new Big(progressBar.completedAmount).div(total);
			var pendingBarWidth = progressBar.pendingAmount ? new Big(progressBar.pendingAmount).div(total) : new Big(0);
			var totalProgressWidth = completedBarWidth.plus(pendingBarWidth);

			if(completedBarWidth.gte(1)) {
				completedBarWidth = new Big(1);
				pendingBarWidth = new Big(0);
			} else if(totalProgressWidth.gte(1)) {
				pendingBarWidth = new Big(1).minus(completedBarWidth);
			}

			$timeout(function() {
				progressBar.completedBarWidth = completedBarWidth.times(100).toPrecision(2);
				progressBar.pendingBarWidth = pendingBarWidth.times(100).toPrecision(2);
			}, 500);
		}

		progressBar.$onChanges = function(changeObj) {
			var shouldUpdateBars = angular.isDefined(progressBar.completedAmount) && angular.isDefined(progressBar.total);
			if(shouldUpdateBars) {
				setWidthPercentages();
			} else {
				progressBar.completedBarWidth = 0;
				progressBar.pendingBarWidth = 0;
			}
		};
	}
})(window.angular);